import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=210ab932&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=210ab932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ab932",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QList,QImg,QIcon,QBtn,QSpinnerIos,QDialog,QItem});
